import CloudBadges from "../../components/CloudBadges";
import BannerDevelopment from "../../components/bannerDevelopment";
import BusinessOtimize from "../../components/businessOtimize";
import NossosServicos from "../../components/nossosServicos";
import Rodape from "../../components/rodape";

function Cloud() {
    return (
        <>
            <BannerDevelopment
                title="/Cloud"
                imageMobile="../assets/banner-cloud-mobile.png"
                backgroundUrl="../assets/cover-cloud.png"
                description={
                    <>
                        Transformação de{" "}
                        <span className="font-inter-bold">alto impacto</span>{" "}
                        com serviços de{" "}
                        <span className="font-inter-bold">
                            computação em nuvem.
                        </span>{" "}
                    </>
                }
                bottomText={
                    <>
                        VERTICAL INNOVATION |{" "}
                        <span className="font-bold">nex</span>
                        2ai
                    </>
                }
                bottomTextMobile="VERTICAL INNOVATION"
                brand="nex2ai"
            />
            <NossosServicos
                servicos={[
                    {
                        id: 1,
                        title: "Migração e modernização",
                        image: "../assets/servicos/migracao_icon.svg",
                        link: "/migracao",
                    },
                    {
                        id: 2,
                        title: "DevOps",
                        image: "../assets/servicos/devops_icon.svg",
                        link: "/devops",
                    },
                    {
                        id: 3,
                        title: "FinOps",
                        image: "../assets/servicos/finops_icon.svg",
                        link: "/finops",
                    },
                    {
                        id: 4,
                        title: "Segurança",
                        image: "../assets/servicos/seguranca_icon.svg",
                        link: "/seguranca",
                    },
                    {
                        id: 5,
                        title: "Monitoramento contínuo",
                        image: "../assets/servicos/monitoramento_icon.svg",
                        link: "/monitoramento",
                    },
                ]}
                description="Soluções em cloud computing para acelerar a transformação digital e otimizar a gestão e performance de negócios."
                bannerImage="../assets/banner-nossos-servicos-cloud.png"
                bgColor="from-[#FC0021] via-[#FC0021] to-[#4B3BDB]"
            />
            <BusinessOtimize
                title={
                    <>
                        Seu negócio pode chegar mais longe com{" "}
                        <span className="font-inter-bold">
                            escalabilidade, flexibilidade, eficiência e
                            segurança na nuvem.
                        </span>
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonTextColor="from-[#FC0021] to-[#FC0021]"
                backgroundImage="../assets/banner-next2a.png"
                bgMobile="../assets/banner-next2a-mobile.png"
                buttonLink="/"
            />
            <CloudBadges />
            <Rodape />
        </>
    );
}

export default Cloud;
